(function () {
	const getAnswer = (toggle) => {
		const answer = toggle.nextElementSibling;

		return answer?.classList.contains("collapsible-content__answer")
			? answer
			: null;
	};

	const setExpanded = (item, expanded) => {
		const toggle = item.querySelector(".collapsible-content__toggle");
		const answer = toggle ? getAnswer(toggle) : null;

		item.classList.toggle("active", expanded);
		toggle?.setAttribute("aria-expanded", expanded ? "true" : "false");

		if (answer) {
			answer.style.display = expanded ? "block" : "none";
		}
	};

	const initCollapsibleContent = (container = document) => {
		container
			.querySelectorAll(".collapsible-content__toggle")
			.forEach((toggle) => {
				const item = toggle.closest(".collapsible-content__item");

				if (!item) return;

				toggle.setAttribute("role", "button");
				toggle.setAttribute("tabindex", "0");
				setExpanded(item, item.classList.contains("active"));

				if (toggle.dataset.collapsibleBound === "true") return;
				toggle.dataset.collapsibleBound = "true";

				const toggleItem = () => {
					const expanding = !item.classList.contains("active");

					if (expanding) {
						item.parentElement
							?.querySelectorAll(".collapsible-content__item.active")
							.forEach((activeItem) => {
								if (activeItem !== item) setExpanded(activeItem, false);
							});
					}

					setExpanded(item, expanding);
				};

				toggle.addEventListener("click", toggleItem);
				toggle.addEventListener("keydown", (event) => {
					if (event.key !== "Enter" && event.key !== " ") return;

					event.preventDefault();
					toggleItem();
				});

				item.addEventListener("mouseenter", () => {
					item.classList.remove("collapsible-content__item--opacity");
					item.parentElement
						?.querySelectorAll(".collapsible-content__item")
						.forEach((sibling) => {
							if (sibling !== item) {
								sibling.classList.add("collapsible-content__item--opacity");
							}
						});
				});

				item.addEventListener("mouseleave", () => {
					item.parentElement
						?.querySelectorAll(".collapsible-content__item--opacity")
						.forEach((sibling) => {
							sibling.classList.remove("collapsible-content__item--opacity");
						});
				});
			});
	};

	document.addEventListener("shopify:section:load", (event) => {
		initCollapsibleContent(event.target);
	});

	initCollapsibleContent();
})();
